/*
 Tap-to-pause for the scrolling banners (snippets/marquee-pause.liquid). One choice covers every
 banner on the page, and is remembered across pages, because a shopper who stops one banner
 doesn't want the next one moving.
*/
(function () {
    if (window.OhSnapMarqueePause) return;
    window.OhSnapMarqueePause = true;

    const STORAGE_KEY = "ohsnap:marqueePaused";

    function readPaused() {
        try {
            return localStorage.getItem(STORAGE_KEY) === "1";
        } catch (e) {
            return false;
        }
    }

    function writePaused(paused) {
        try {
            if (paused) localStorage.setItem(STORAGE_KEY, "1");
            else localStorage.removeItem(STORAGE_KEY);
        } catch (e) {}
    }

    function setPaused(banner, paused) {
        banner.classList.toggle("marqueePaused", paused);
        const toggle = banner.querySelector("[data-marquee-toggle]");
        if (!toggle) return;
        const label = paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause;
        toggle.setAttribute("aria-label", label);
        toggle.setAttribute("title", label);
    }

    function setAll(paused) {
        document.querySelectorAll("[data-marquee]").forEach(function (banner) {
            // Hands the banner to the shopper: its pause-on-hover stops applying (CSS)
            banner.classList.add("marqueeToggled");
            setPaused(banner, paused);
        });
    }

    function init(root) {
        const paused = readPaused();
        root.querySelectorAll("[data-marquee-toggle]").forEach(function (toggle) {
            const banner = toggle.closest("[data-marquee]");
            if (!banner || toggle.dataset.marqueeReady) return;
            toggle.dataset.marqueeReady = "1";
            setPaused(banner, paused);
            toggle.hidden = false;
            banner.classList.add("marqueeReady");
            toggle.addEventListener("click", function () {
                const next = !banner.classList.contains("marqueePaused");
                writePaused(next);
                setAll(next);
            });
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () {
            init(document);
        });
    } else {
        init(document);
    }

    // Theme editor re-renders a section in place
    document.addEventListener("shopify:section:load", function (event) {
        init(event.target);
    });
})();
